import React from "react";
import { intl } from "LocaleWrapper";
import { useStoreState } from "ezStore";
import { FormGroup } from "@cofano/cck";
import { Grid2 as Grid, Typography } from "@mui/material";
import { OpeningHoursDetails } from "components/openinghours/OpeningHours";
import { Language, hasOptionalFieldPermission, Fields, DataFormat } from "imports/Utils";
import { ShipFromQuery } from "view/ships/ShipDetails";
import ShipAvailabilityTable from "view/ships/components/table/ShipAvailabilityTable";

const ShipAvailabilityDetails = ({ ship, refetch }: { ship: ShipFromQuery; refetch: () => void }) => {

	const session = useStoreState(store => store.session);
	const availability = ship.availability;

	return (
		<React.Fragment>
			<Grid container spacing={3}>
				<Grid size={6}>
					<FormGroup label={Language("SHIP_AVAILABLE_DAYS")} labelPlacement="left-center" overflow="hidden">
						{Language(`SHIP_AVAILABLEDAYS_${availability?.availableSunday ? 3 : (availability?.availableSaturday ? 2 : 1)}`)}
					</FormGroup>

					{hasOptionalFieldPermission(session, Fields.SHIP, "availableHoursADay") && (
						<FormGroup label={Language("SHIP_AVAILABLE_HOURS_A_DAY")} labelPlacement="left-center" overflow="hidden">
							{availability?.availableHoursADay && availability?.availableDayNight && `${availability?.availableHoursADay} (${intl.formatMessage({ id: availability?.availableDayNight as string })})`}
						</FormGroup>
					)}

					<FormGroup label={Language("SHIP_AVAILABILITY")} labelPlacement="left-center" overflow="hidden">
						{DataFormat.boolean(availability?.defaultAvailability)}
					</FormGroup>
				</Grid>

				<Grid size={6}>
					<Typography
						variant="h4"
						fontWeight="medium"
						fontSize="18px"
						color="text.primary"
						mb={2}>
						{Language("WORKING_HOURS")}
					</Typography>

					<OpeningHoursDetails hours={ship.workingHours ?? null} />
				</Grid>

				<Grid size={12}>
					<ShipAvailabilityTable
						availabilityExceptions={ship.availabilityExceptions}
						defaultAvailability={ship.availability?.defaultAvailability ?? false}
						shipId={ship.id}
						refetch={refetch} />
				</Grid>
			</Grid>
		</React.Fragment>
	);
};

export default ShipAvailabilityDetails;
